"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pipe = pipe;
Object.defineProperty(exports, "Form", {
  enumerable: true,
  get: function get() {
    return _Form["default"];
  }
});
Object.defineProperty(exports, "Group", {
  enumerable: true,
  get: function get() {
    return _Group["default"];
  }
});
Object.defineProperty(exports, "ArrayGroup", {
  enumerable: true,
  get: function get() {
    return _ArrayGroup["default"];
  }
});
Object.defineProperty(exports, "useFormInput", {
  enumerable: true,
  get: function get() {
    return _useFormInput["default"];
  }
});
Object.defineProperty(exports, "useFormSubmit", {
  enumerable: true,
  get: function get() {
    return _useFormSubmit["default"];
  }
});
Object.defineProperty(exports, "useFormValidator", {
  enumerable: true,
  get: function get() {
    return _useFormValidator["default"];
  }
});
Object.defineProperty(exports, "useFormValue", {
  enumerable: true,
  get: function get() {
    return _useFormValue["default"];
  }
});
Object.defineProperty(exports, "useFormParent", {
  enumerable: true,
  get: function get() {
    return _useFormParent["default"];
  }
});
Object.defineProperty(exports, "useFormArrayOperator", {
  enumerable: true,
  get: function get() {
    return _useFormArrayOperator["default"];
  }
});

var _Form = _interopRequireDefault(require("./Form"));

var _Group = _interopRequireDefault(require("./Group"));

var _ArrayGroup = _interopRequireDefault(require("./ArrayGroup"));

var _useFormInput = _interopRequireDefault(require("./useFormInput"));

var _useFormSubmit = _interopRequireDefault(require("./useFormSubmit"));

var _useFormValidator = _interopRequireDefault(require("./useFormValidator"));

var _useFormValue = _interopRequireDefault(require("./useFormValue"));

var _useFormParent = _interopRequireDefault(require("./useFormParent"));

var _useFormArrayOperator = _interopRequireDefault(require("./useFormArrayOperator"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function pipe() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return function (value) {
    for (var i = 0; i < validators.length; i += 1) {
      validators[i](value);
    }
  };
}